import { getAdapter, env } from '@zyf2e/adapt';
import router from '@/router/index'

/**
 * just wait
 * @param duration wait time
 */
export const wait = (duration: number): Promise<void> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
};

export const setScroll = (): void => {
  const classList = document.body.className;
  document.body.className = classList.replace(/overflow-hidden/gm, '');
};

export const hideScroll = (): void => {
  const classList = document.body.className;
  document.body.className = classList + ' overflow-hidden';
};

export const clone = (obj: object): object => {
  return obj && JSON.parse(JSON.stringify(obj));
};

export const parseParam = (json: { [key: string]: any }): string => {
  if (!json) return '/';
  return (
    '?' +
    Object.keys(json)
      .map(v => {
        return json[v] ? `${v}=${json[v]}` : false;
      })
      .filter(el => el)
      .join('&')
  );
};

export const getUrlParam = (name: string) => {
  const search = window.location.hash.split('?');
  if (!search[1]) {
    return null;
  }
  const params = search[1].split('&');
  let result = null;
  try {
    params.forEach(val => {
      const arr = val.split('=');
      if (name === arr[0]) {
        result = unescape(arr[1]);
        throw new Error('exist');
      }
    });
  } catch (error) {
    // do nothing
  }
  return result;
};

interface IpayHandleParams {
  [key: string]: any;
  tradeNo: string;
  bizId?: string;
  consultId?: number | string;
  channel?: number | string;
  doctorId?: number | string;
  sessionId?: number | string;
}

export const getPathEnv = () => {
  const { pathname } = window.location;
  if (/qatest-newc-dev/.test(pathname)) {
    return 'qatest-newc-dev/';
  }
  if (/qatest-newc-qa/.test(pathname)) {
    return 'qatest-newc-qa/';
  }
  return '';
};

export const payHandle = ({
  tradeNo,
  bizId = 'C_TERMINAL',
  consultId,
  channel,
  doctorId,
  sessionId
}: IpayHandleParams): any => {
  if (!tradeNo) return;

  const callbackObj = {
    domain: `${process.env.VUE_APP_STATIC}/${process.env.VUE_APP_PATH || 'f2e'}/kangm-patient-clinic/${getPathEnv()}`,
    success: '/pay/success',
    fail: '/pay/fail',
    params: {
      channel,
      consultId,
      doctorId,
      sessionId
    }
  };
  const successUrl = encodeURIComponent(
    `${callbackObj.domain}#${callbackObj.success}${parseParam(callbackObj.params)}`
  );

  const failUrl = encodeURIComponent(`${callbackObj.domain}#${callbackObj.fail}${parseParam(callbackObj.params)}`);
  const orderUrl = encodeURIComponent(
    `${process.env.VUE_APP_STATIC}/${process.env.VUE_APP_PATH || 'f2e'}/more-project/${getPathEnv()}patient-consulted-list/#/`
  );
  const payParam = {
    bizId,
    tradeNo,
    successUrl,
    failUrl,
    orderUrl,
    channel
  };

  if (env.inWechatMiniProgram) {
    window.wx.miniProgram.navigateTo({
      url: `/pages/pay/pay${parseParam(payParam)}`
    });
    return;
  }

  console.log(payParam);
  
  let origin = process.env.VUE_APP_STATIC;
  // location.href = `${origin}/f2e/checkout/${getPathEnv()}#/checkout${parseParam(payParam)}`
  // getAdapter().replace(`${origin}/f2e/kangm-checkout/#/checkout${parseParam(payParam)}`);
  // getAdapter().replace(`${origin}/${process.env.VUE_APP_PATH || 'f2e'}/checkout/${getPathEnv()}#/checkout${parseParam(payParam)}`);
  // console.log(`${origin}/${process.env.VUE_APP_PATH || 'f2e'}/checkout/${getPathEnv()}#/checkout${parseParam(payParam)}`);
  // console.log(payParam);
  router.replace({
    name: '/checkout',
    query: {
      ...payParam
    }
  })
};
